import React, { createContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  // 🔹 Função para verificar autenticação
  const checkAuth = useCallback(() => {
    console.log("🔹 Verificando autenticação...");
    const token = localStorage.getItem("token");
    const adminStatus = localStorage.getItem("is_admin") === "true";

    if (token) {
      setIsAuthenticated(true);
      setIsAdmin(adminStatus);
    } else {
      setIsAuthenticated(false);
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  // 🔹 Função para login
  const login = useCallback((token, admin, refreshToken) => {
    console.log("✅ Usuário logado com sucesso!");
    localStorage.setItem("token", token);
    localStorage.setItem("is_admin", admin ? "true" : "false");
    if (refreshToken) localStorage.setItem("refresh_token", refreshToken);
    setIsAuthenticated(true);
    setIsAdmin(admin);
    navigate("/", { replace: true });
  }, [navigate]);

  // 🔹 Função para logout
  const logout = useCallback(() => {
    console.log("🔹 Realizando logout...");
    localStorage.removeItem("token");
    localStorage.removeItem("is_admin");
    setIsAuthenticated(false);
    setIsAdmin(false);
    navigate("/login", { replace: true });
  }, [navigate]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isAuthenticated === null) {
    return <div>Carregando...</div>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
